import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as html2pdf from "html2pdf.js";

export const downloadPDFPaginaUnica = async (
  titulo: string,
  elemento: HTMLElement
) => {
  html2canvas(elemento, {
    scale: 2,
    windowWidth: 50,
  }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    pdf.addImage(imgData, "JPG", 15, 2, 178, elemento.offsetHeight / 4.5);
    pdf.save(`${titulo}.pdf`);
  });
};

export const downloadPDFMultiPagina = async (
  titulo: string,
  elemento: HTMLElement
) => {
  const opt = {
    margin: [1, 1, 6, 1],
    filename: `${titulo}.pdf`,
    image: {
      type: "jpeg",
      quality: 1,
    },
    html2canvas: {
      scale: 2,
      width: 760,
    },
  };

  const elementoImpressao = document.createElement("div");
  elementoImpressao.appendChild(elemento.cloneNode(true));

  elementoImpressao.style.transform = "scale(0.82) translate(0, -10%)";

  html2pdf().from(elementoImpressao).set(opt).save();
};

export function validarPeriodo(dataInicio: string, dataFim: string): boolean {
  if (!validarData(dataInicio) || !validarData(dataFim)) return false;
  return dataFim > dataInicio;
}

export function validarData(data?: string | null): boolean {
  if (data === undefined || data === null || data.length === 0) return false;

  const date = data.substring(0, 10);
  const [a, m, d] = date.split("-");

  const ano = Number(a);
  const mes = Number(m);
  const dia = Number(d);

  if (mes > 12 || mes < 1 || dia < 1) return false;
  if (dia > getMonthLastDay(mes, ano)) return false;

  return true;
}
export function validarDataNascimento(data?: string | null): boolean {
  if (data === undefined || data === null || data.length === 0) return false;

  const date = data.substring(0, 10);
  const [a] = date.split("-");

  if (Number(a) < new Date().getFullYear() - 130) {
    return false;
  }
  return validarData(data);
}

export function anoBissexto(ano: number): boolean {
  return ano % 4 === 0 && (ano % 100 !== 0 || ano % 400 === 0);
}

export function formatMoney(value?: number, floor?: boolean): string {
  if (!value) return "0,00";
  return (floor ? Math.floor(value * 100) / 100 : value).toLocaleString(
    "pt-BR",
    {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }
  );
}

export function moneyToNumber(value?: string): number {
  if (!value) return 0.0;
  return Number(value.replaceAll(".", "").replace(",", "."));
}

export function formatData(data: string): string {
  const date = data.substring(0, 10);

  return date.split("-").reverse().join("/");
}

export function formatDataBr(data: string): string {
  const date = data.substring(0, 10);

  return date.split("/").reverse().join("-");
}

export function formatCPF(cpf: string): string {
  const cpfFormatado = `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(
    6,
    9
  )}-${cpf.slice(9)}`;
  return cpfFormatado;
}

export function formatCompetence(
  data?: number,
  strFormat: boolean = true
): string {
  if (!data) return "";
  let str = "";
  if (strFormat) {
    str += getMonthName(data % 100);
  } else {
    str += `${data % 100}`;
  }
  str += `/${data}`.substring(0, 5);
  return str;
}

function getMonthName(mes: number): string {
  if (mes < 1 || mes > 12) return "";

  const months = [
    "",
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  return months[mes].toUpperCase();
}
function monthDays(year: number): number[] {
  return [
    31,
    anoBissexto(year) ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
}

function getMonthLastDay(month: number, year: number): number {
  return monthDays(year)[month - 1];
}

function dateString(
  year: number | string,
  month: number | string,
  date: number | string
): string {
  return `${year}-${`${month}`.padStart(2, "0")}-${`${date}`.padStart(2, "0")}`;
}

export function getMonthRange(monthsBefore: number = 0): string[] {
  if (monthsBefore > 12) {
    throw Error("A quantidade de meses antes não pode ser maior que 12");
  }

  const now: Date = new Date();
  let month = now.getMonth() + 1;
  let year = now.getFullYear();

  if (monthsBefore !== 0) {
    month = month - monthsBefore;

    if (month <= 0) {
      month = 12 - month;
      year -= 1;
    }
  }

  const lastDate = getMonthLastDay(month, year);

  const start = dateString(year, month, 1);
  const end = dateString(year, month, lastDate);

  return [start.split("T")[0], end.split("T")[0]];
}

export function delay(time: number) {
  return new Promise((resolve) => setTimeout(resolve, time));
}
